import { useContext } from 'solid-js';
import clsx from 'clsx';
import { ErrorCatcher } from '../../../../../../tools/error-catcher';
import { ImageSrcData, getBackgroundImageSrcData } from '../../../../../image-component/image-component';
import { Focus, focusPosition } from '../../../../../../tools/get-image-focus';
import { AppContext } from '../../../../../../app-context-provider/app-context-provider';
import { ImageWordpress } from '../../../../../../types/shared';
import { OverlayType } from '../../../../../../grid-system/section/section-types';
import { SpacerPdf } from '../spacer/spacer-pdf';

type BackgroundImagePDFProps = {
    src: string;
    focus: Focus;
    overlayType?: OverlayType;
    roundCorners?: boolean;
};

export const BackgroundImagePDF = (props: BackgroundImagePDFProps) => {
    const { imagesServiceUrl, supportedImageFormats } = useContext(AppContext);

    const getBackgroundImage = () => {
        if (props.src) {
            const backgroundImage: ImageSrcData = getBackgroundImageSrcData({
                imagesServiceUrl,
                supportedImageFormats,
                src: props.src,
                width: 960,
                height: 'AUTO',
            });
            return backgroundImage;
        }
    };

    const bgImage = () => getBackgroundImage();
    const hasBgImage = () => bgImage() && bgImage()!.original !== '';

    return (
        <ErrorCatcher componentName='Hero-PDF'>
            <div>
                <SpacerPdf height={1} />
                <div
                    class={clsx(
                        'h-[19rem] relative p-10 pt-px w-[85%]',
                        props.roundCorners && 'rounded-[0.73rem]',
                        hasBgImage() && 'pdf-beige-overlay bg-no-repeat bg-cover',
                        hasBgImage() && (props.overlayType === 'on' ? '[&::before]:opacity-30' : '[&::before]:opacity-0')
                    )}
                    style={hasBgImage() ? {
                        'background-image': `url(${bgImage()!.original})`,
                        'background-position': focusPosition(props.focus) || 'center',
                    } : undefined}
                />
                <SpacerPdf height={2} />
            </div>
        </ErrorCatcher>
    );
};

BackgroundImagePDF.parseProps = (atts: { image: ImageWordpress, overlayType: OverlayType, roundCorners: boolean }) => {
    const { image, overlayType, roundCorners } = atts;

    return {
        src: image?.url,
        focus: image?.focus,
        overlayType,
        roundCorners,
    };
};
